































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component
export default class App extends Vue {
  private logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.$store.dispatch('setUser', {});
    this.$router.push('/login');
  }

  get user() {
    return this.$store.getters.getUser;
  }
}
